import type { Component } from 'vue';
import ErrorPopup from '../components/popup/ErrorPopup.vue';

interface GlobalPopupStateModel {
  component: any
  props: any
  showContent: boolean
}

const POPUPS: Record<string, Component> = { ErrorPopup };

const defaultProps = {
  transition: { name: 'slide-up' },
  selfClick: true,
};

const globalPopupState = reactive<GlobalPopupStateModel>({
  component: null,
  props: defaultProps,
  showContent: false,
});
export function usePopups() {
  const openPopup = (name: string, props = {}) => {
    globalPopupState.component = POPUPS[name];
    globalPopupState.props = { ...defaultProps, ...props };
  };

  const toggleComponent = (state?: boolean) => {
    globalPopupState.showContent = typeof state === 'boolean' ? state : !globalPopupState.showContent;
  };
  const closePopup = () => {
    globalPopupState.component = null;
    globalPopupState.props = defaultProps;
  };

  return { globalPopupState, closePopup, openPopup, toggleComponent };
}
